<template>
  <Row :gutter="20" style="height: 100%">
    <Col
      span="6"
      style="height: 100%"
      v-for="(item, index) in items"
      :key="index"
    >
      <div
        style="height: 100%; color: #fff;border-radius: 20px 0 20px 0;"
        class="deskblock"
        :style="{ background: item.background }"
      >
        <div class="title">
          <h3>{{ item.title }}</h3>
          <span>昨日 {{ item.allNum }}</span>
        </div>

        <h2>
          {{ item.num }} <span class="unit">{{ item.unit }}</span>
        </h2>
      </div>
    </Col>
  </Row>
</template>
<script>
import deskTime from "../time.vue";
export default {
  components: { deskTime },
  data() {
    return {
      items: [
        {
          num: 0,
          title: "接打电话次数",
          icon: "",
          mintitle: "7天累计",
          allNum: 0,
          unit: "今日",
          background: "#fbc83b",
        },
        {
          num: 0,
          title: "抽烟驾驶次数",
          icon: "",
          mintitle: "7天累计",
          allNum: 0,
          unit: "今日",
          background: "#25d37c",
        },

        {
          num: 0,
          title: "疲劳驾驶次数",
          icon: "",
          mintitle: "7天累计",
          allNum: 0,
          unit: "今日",
          background: "#34a4f8",
        },
        {
          num: 0,
          title: "前向碰撞次数",
          icon: "",
          mintitle: "7天累计",
          allNum: 0,
          unit: "今日",
          background: "#bd71d5",
        },
      ],
      searchItem: {
        startTime: 0,
        endTime: 0,
      },
    };
  },
  methods: {
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/sumAlarmAsc",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;

        var t = this.items;
        t[0].num = data.telAlarm;
        t[1].num = data.smokeAlarm;
        t[2].num = data.tiredAlarm;
        t[3].num = data.collideAlarm;
      });
    },
    getYestodayData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/sumAlarmAsc",
        data: {
          startTime: this.searchItem.startTime-86400000,
          endTime: this.searchItem.endTime-86400000,
        },
      }).then((res) => {
        var data = res.data.data;

        var t = this.items;
        t[0].allNum = data.telAlarm;
        t[1].allNum = data.smokeAlarm;
        t[2].allNum = data.tiredAlarm;
        t[3].allNum = data.collideAlarm;
        
      });
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();
      this.searchItem.startTime = new Date(this.yy, this.mm, this.dd).getTime();
      this.searchItem.endTime =
        new Date(this.yy, this.mm, this.dd + 1).getTime() - 1000;
      this.getData();
      this.getYestodayData();
    },
  },
  mounted() {
    this.defaultTime();
  },
};
</script>
<style>
.deskblock .blockbottom {
  display: flex;
  
}
.deskblock .title {
  display: flex;
}
.deskblock .title h3 {
  margin-right: auto;
}
.deskblock h2 {
  font-size: 42px;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  display: inline-block;
  font-weight: bold;
}
.deskblock h2 span.unit {
  background: #ef6f5e;
  width: 48px;
  height: 24px;
  border-radius: 24px;
  color: white;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 10px;
  right: -54px;
}
.deskblock .blockbottom p:nth-child(2) {
  margin-top: -4px;
  margin-left: auto;
  min-width: 50px;
  text-align: center;
  color: #333;
  background: #ffffff;
  border-radius: 20px;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/workDesk/allData/block1.vue